<div>
  <input #input id="md-input-file" type="file" [attr.multiple]="multiple? '' : null">
  <span class="filename">{{fileNames}}</span>
</div>